import { render, staticRenderFns } from "./SettingsConversion.vue?vue&type=template&id=5a2f560a"
import script from "./SettingsConversion.vue?vue&type=script&lang=js"
export * from "./SettingsConversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports